<template>
	<div>
		<section>
			<link rel="preconnect" href="https://fonts.googleapis.com" /><link
				rel="preconnect"
				href="https://fonts.gstatic.com"
				crossorigin
			/><link
				href="https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;700&display=swap"
				rel="stylesheet"
			/>
			<div class="grid">
				<div id="item-0">
					<div class="curso__header">
						<div class="curso__header___select">
							<img
								v-if="
									Object.keys(this.$store.state.product)
										.length > 0
								"
								class="curso__header___img"
								src="@/assets/Vector-carrinho.svg"
								alt=""
							/>
							<h2
								v-if="
									Object.keys(this.$store.state.product)
										.length > 0
								"
							>
								{{ this.$store.state.product.name }}
							</h2>
							<Skeleton v-else :width="'65%'" :height="'50px'" />
						</div>
						<!-- <div class="curso__header___cursos">
						<h2>cursos</h2>
					</div> -->
						<div
							v-if="this.$store.state.token"
							class="curso__header___menu"
							@click="openMenu"
						>
							<a class="botao-menu">
								<div class="menu_image"></div>

								<!-- <img alt="" class="menu_image" /> -->
							</a>
						</div>
					</div>
				</div>
				<div id="item-1">
					<div class="compra">
						<h2>Resumo da compra</h2>

						<div class="curso">
							<h3>Evento</h3>
							<p
								v-if="
									Object.keys(this.$store.state.product)
										.length > 0
								"
							>
								{{ this.$store.state.product.name }}
							</p>
							<Skeleton v-else :width="'40%'" :height="'30px'" />
						</div>
						<div class="descricao">
							<h3>Descrição</h3>
							<p
								class="descricao__text"
								v-if="
									Object.keys(this.$store.state.product)
										.length > 0
								"
							>
								{{
									cleanHtml(
										this.$store.state.product.description
									)
								}}
							</p>
							<Skeleton
								v-else
								class="descricao__text"
								:width="'40%'"
								:height="'20px'"
								:margin="'15px 0'"
							/>
						</div>

						<!-- <div
							class="descricao"
							v-if="
								this.$store.state.product.participants_limit > 0
							"
						>
							<div
								v-if="
									this.$store.state.product
										.participants_limit -
										this.$store.state.product
											.registereds !==
									0
								"
							>
								<h3>Inscrições abertas:</h3>

								<p
									class="descricao__text"
									v-if="
										Object.keys(this.$store.state.product)
											.length > 0
									"
								>
									Inscrições restantes:
									{{
										this.$store.state.product
											.participants_limit -
										this.$store.state.product.registereds
									}}
								</p>
								<Skeleton
									v-else
									class="descricao__text"
									:width="'40%'"
									:height="'20px'"
									:margin="'15px 0'"
								/>
							</div> -->
						<div
							style="text-align: center"
							v-if="
								this.$store.state.product.participants_limit -
									this.$store.state.product.registereds <
									1 &&
								this.$store.state.product.participants_limit > 0
							"
						>
							<h3 style="color: gray">Inscrições Encerradas</h3>
						</div>
						<!-- </div> -->
						<!-- <div class="taxa">
						<h3>taxa de inscrição</h3>
						<p>R$ 90,00</p>
					</div> -->
						<div class="investimento">
							<h3>valor total</h3>
							<p
								v-if="
									Object.keys(this.$store.state.product)
										.length > 0
								"
							>
								{{ moneyMask(this.$store.state.product.price) }}
							</p>
							<Skeleton v-else :width="'10%'" :height="'30px'" />
						</div>
					</div>
					<div class="social_media">
						<h2>Compartilhe nas suas redes sociais</h2>
						<ul class="social_container">
							<a
								class="social_box"
								v-bind:href="
									'https://www.facebook.com/sharer/sharer.php?u=https://sso.gruposantajoana.com.br/carrinho?slug=' +
									this.$store.state.product.slug
								"
								target="_blank"
							>
								<li>
									<svg
										width="10"
										height="16"
										viewBox="0 0 10 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										class="social_icon"
									>
										<path
											d="M6.75 6.125H9.75V8.9375H6.75V15.5H3.75V8.9375H0.75V6.125H3.75V4.94844C3.75 3.83375 4.124 2.42562 4.868 1.65594C5.612 0.884375 6.541 0.5 7.654 0.5H9.75V3.3125H7.65C7.152 3.3125 6.75 3.68938 6.75 4.15531V6.125Z"
											fill="white"
										/>
									</svg>
								</li>
							</a>
							<a
								class="social_box"
								v-bind:href="'https://www.instagram.com/hmsantajoana/'"
								target="_blank"
							>
								<li>
									<svg
										width="15"
										height="14"
										viewBox="0 0 15 14"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										class="social_icon"
									>
										<path
											d="M12.1775 3.3425C12.1811 3.4512 12.1627 3.55951 12.1236 3.66099C12.0845 3.76246 12.0253 3.85504 11.9497 3.93319C11.8741 4.01135 11.7835 4.0735 11.6834 4.11594C11.5832 4.15839 11.4756 4.18026 11.3668 4.18026C11.2581 4.18026 11.1504 4.15839 11.0503 4.11594C10.9501 4.0735 10.8596 4.01135 10.7839 3.93319C10.7083 3.85504 10.6491 3.76246 10.61 3.66099C10.5709 3.55951 10.5526 3.4512 10.5561 3.3425C10.563 3.1321 10.6515 2.93263 10.8028 2.78624C10.954 2.63985 11.1563 2.55801 11.3668 2.55801C11.5773 2.55801 11.7796 2.63985 11.9309 2.78624C12.0821 2.93263 12.1706 3.1321 12.1775 3.3425ZM14.75 7V7.0105L14.7036 9.947C14.6918 11.006 14.2659 12.0184 13.5171 12.7674C12.7683 13.5163 11.756 13.9424 10.697 13.9545L7.75 14H7.7395L4.803 13.9536C3.74396 13.9418 2.73163 13.5159 1.98265 12.7671C1.23367 12.0183 0.807552 11.006 0.7955 9.947L0.75 7V6.9895L0.796375 4.053C0.8082 2.99381 1.23421 1.98135 1.98322 1.23234C2.73222 0.48334 3.74469 0.0573254 4.80388 0.0455L7.74913 0H7.75963L10.6961 0.046375C11.7553 0.0582004 12.7678 0.484215 13.5168 1.23322C14.2658 1.98222 14.6918 2.99469 14.7036 4.05387L14.7491 7H14.75ZM13.4462 7L13.4008 4.07312C13.3923 3.35332 13.1027 2.66536 12.5937 2.15635C12.0846 1.64733 11.3967 1.35766 10.6769 1.34925L7.75 1.30375L4.82313 1.34925C4.10325 1.35743 3.41516 1.64704 2.9061 2.1561C2.39704 2.66516 2.10743 3.35325 2.09925 4.07312L2.05375 7L2.09925 9.92688C2.10766 10.6467 2.39733 11.3346 2.90635 11.8437C3.41536 12.3527 4.10332 12.6423 4.82313 12.6508L7.75 12.6962L10.6769 12.6508C11.3967 12.6423 12.0846 12.3527 12.5937 11.8437C13.1027 11.3346 13.3923 10.6467 13.4008 9.92688L13.4462 7ZM11.3445 7C11.3445 7.95332 10.9658 8.8676 10.2917 9.5417C9.6176 10.2158 8.70332 10.5945 7.75 10.5945C6.79668 10.5945 5.8824 10.2158 5.2083 9.5417C4.53421 8.8676 4.1555 7.95332 4.1555 7C4.1555 6.04668 4.53421 5.1324 5.2083 4.4583C5.8824 3.78421 6.79668 3.4055 7.75 3.4055C8.70332 3.4055 9.6176 3.78421 10.2917 4.4583C10.9658 5.1324 11.3445 6.04668 11.3445 7ZM10.0408 7C10.0467 6.69547 9.99186 6.3928 9.87944 6.10971C9.76701 5.82663 9.59926 5.56881 9.38599 5.35133C9.17273 5.13386 8.91823 4.9611 8.6374 4.84316C8.35657 4.72523 8.05503 4.66448 7.75044 4.66448C7.44584 4.66448 7.14431 4.72523 6.86348 4.84316C6.58264 4.9611 6.32815 5.13386 6.11488 5.35133C5.90162 5.56881 5.73386 5.82663 5.62144 6.10971C5.50901 6.3928 5.45417 6.69547 5.46013 7C5.47185 7.59968 5.7183 8.17084 6.14654 8.59079C6.57478 9.01074 7.15065 9.24598 7.75044 9.24598C8.35023 9.24598 8.9261 9.01074 9.35434 8.59079C9.78258 8.17084 10.029 7.59968 10.0408 7Z"
											fill="white"
										/>
									</svg>
								</li>
							</a>
							<a
								class="social_box"
								v-bind:href="
									'https://api.whatsapp.com/send?text=https://sso.gruposantajoana.com.br/carrinho?slug=' +
									this.$store.state.product.slug
								"
								target="_blank"
							>
								<li>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="10 10 45 44"
										width="192px"
										height="192px"
										class="social_icon"
									>
										<path
											d="M 32 10 C 19.85 10 10 19.85 10 32 C 10 36.065 11.10725 39.869719 13.03125 43.136719 L 10.214844 53.683594 L 21.277344 51.208984 C 24.450344 52.983984 28.106 54 32 54 C 44.15 54 54 44.15 54 32 C 54 19.85 44.15 10 32 10 z M 32 14 C 41.941 14 50 22.059 50 32 C 50 41.941 41.941 50 32 50 C 28.269 50 24.803687 48.864875 21.929688 46.921875 L 15.791016 48.294922 L 17.353516 42.439453 C 15.250516 39.493453 14 35.896 14 32 C 14 22.059 22.059 14 32 14 z M 24.472656 21.736328 C 24.105656 21.736328 23.515672 21.871969 23.013672 22.417969 C 22.520672 22.964969 21.113281 24.278844 21.113281 26.964844 C 21.113281 29.640844 23.057078 32.23675 23.330078 32.59375 C 23.603078 32.96075 27.100531 38.639266 32.644531 40.822266 C 37.240531 42.632266 38.179547 42.273688 39.185547 42.179688 C 40.183547 42.093688 42.408328 40.866703 42.861328 39.595703 C 43.313328 38.323703 43.312875 37.232906 43.171875 37.003906 C 43.034875 36.781906 42.676859 36.644094 42.130859 36.371094 C 41.584859 36.097094 38.906297 34.777656 38.404297 34.597656 C 37.909297 34.417656 37.542547 34.323141 37.185547 34.869141 C 36.818547 35.415141 35.778125 36.643953 35.453125 37.001953 C 35.138125 37.368953 34.823344 37.411672 34.277344 37.138672 C 33.731344 36.865672 31.975531 36.292594 29.894531 34.433594 C 28.275531 32.992594 27.182188 31.208063 26.867188 30.664062 C 26.551188 30.119062 26.832469 29.821828 27.105469 29.548828 C 27.353469 29.310828 27.652781 28.916563 27.925781 28.601562 C 28.189781 28.277563 28.282891 28.056453 28.462891 27.689453 C 28.651891 27.332453 28.555922 27.007375 28.419922 26.734375 C 28.284922 26.460375 27.226234 23.765406 26.740234 22.691406 C 26.332234 21.787406 25.905672 21.760953 25.513672 21.751953 C 25.196672 21.735953 24.829656 21.736328 24.472656 21.736328 z"
											fill="white"
										/>
									</svg>
								</li>
							</a>

							<a
								class="social_box"
								v-bind:href="
									'https://www.linkedin.com/shareArticle?mini=true&url=https://sso.gruposantajoana.com.br/carrinho?slug=' +
									this.$store.state.product.slug +
									'&title=' +
									this.$store.state.product.name
								"
								target="_blank"
							>
								<li>
									<svg
										width="13"
										height="14"
										viewBox="0 0 13 14"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										class="social_icon"
									>
										<path
											d="M2.09025 3.2458C2.82217 3.2458 3.4155 2.66955 3.4155 1.95872C3.4155 1.24788 2.82217 0.671631 2.09025 0.671631C1.35833 0.671631 0.764999 1.24788 0.764999 1.95872C0.764999 2.66955 1.35833 3.2458 2.09025 3.2458Z"
											fill="white"
										/>
										<path
											d="M3.33 13.3284H0.764999V4.7478H3.33V13.3284ZM12.735 13.3284H10.17V8.74463C10.17 7.55022 9.74592 6.95558 8.90545 6.95558C8.23941 6.95558 7.81704 7.28851 7.605 7.95522V13.3284H5.04C5.04 13.3284 5.0742 5.60586 5.04 4.7478H7.06464L7.2211 6.46392H7.27411C7.79994 5.60586 8.6404 5.0241 9.79294 5.0241C10.6693 5.0241 11.3781 5.26864 11.9193 5.88301C12.464 6.49824 12.735 7.32369 12.735 8.48292V13.3284Z"
											fill="white"
										/>
									</svg>
								</li>
							</a>
						</ul>
					</div>
				</div>

				<div id="item-2">
					<slot></slot>
				</div>

				<div id="item-3">
					<a href="https://gruposantajoana.com.br/ensinoepesquisa/"
						><img src="..\assets\Logo_gsj.png" alt="" class="logo"
					/></a>
				</div>
			</div>

			<!-- 	<FooterPattern /> -->
			<MenuWidget ref="menu" />
		</section>
	</div>
</template>

<script>
import { moneyMask } from "@/utils/moneyMask"
import { cleanHtml } from "@/utils/parseHtmlString"

//import FooterPattern from "@/components/FooterPattern.vue"
import Skeleton from "@/components/SkeletonWidget.vue"
import MenuWidget from "./MenuWidget.vue"

export default {
	components: {
		/* FooterPattern, */
		MenuWidget,
		Skeleton
	},
	methods: {
		cleanHtml,
		moneyMask,
		openMenu() {
			this.$refs.menu.openMenu()
		}
	}
}
</script>

<style>
.menu_image {
	background-image: url("@/assets/menu.svg");
	background-repeat: no-repeat;
	width: 30px;
	height: 30px;
}

.menu_image.active {
	background-image: url("@/assets/close.svg");
	background-repeat: no-repeat;
	width: 20px;
	height: 20px;
	filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(90deg)
		brightness(99%) contrast(105%);
}
.social_media {
	color: rgb(255, 255, 255);
	text-align: left;
	align-items: center;
	width: 90%;
	height: auto;
	margin: 70px 5%;
	font-family: "Montserrat", sans-serif;
	font-size: 80;
}

.social_container {
	display: flex;
	justify-content: space-between;
	text-align: center;
	align-items: center;
	margin: 0;
	padding: 0;
}

@media (min-width: 768px) {
	.social_box {
		border: 3px solid rgb(255, 255, 255);
	}
}

@media (max-width: 768px) {
	.social_box {
		border: 2px solid rgb(255, 255, 255);
	}
}

@media (max-width: 400px) {
	.social_box {
		border: 1px solid rgb(255, 255, 255);
		max-height: 20px;
		max-width: 50px;
	}
}

.social_box {
	border-radius: 10px;
	border: 3px solid rgb(255, 255, 255);
	width: 18%;
	list-style: none;
	text-align: center;
	padding: 10px;
}

.social_icon {
	height: 20px;
	width: 25px;
}

@media only screen and (max-width: 1800px) and (min-width: 770px) {
	.curso {
		flex-wrap: wrap;
	}
	.curso h3 {
		margin: auto 0;
	}
}
</style>
